import { useEffect } from 'react'

const GTM_ID = 'GTM-NX2B3JNL'

declare global {
    interface Window {
        dataLayer: unknown[]
    }
}

/**
 * Hook to initialize Google Tag Manager on a page.
 * Safe to call multiple times - will only initialize once.
 * Injects both the head script and the noscript fallback in body.
 */
export function useGTM(): void {
    useEffect(() => {
        // Check if GTM is already initialized
        if (window.dataLayer?.some((item) => typeof item === 'object' && item !== null && 'gtm.start' in item)) {
            return
        }

        // Initialize dataLayer and push gtm.start event (exactly as Google's snippet)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

        // Create and inject GTM script into head
        const script = document.createElement('script')
        script.async = true
        script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
        const firstScript = document.getElementsByTagName('script')[0]
        firstScript?.parentNode?.insertBefore(script, firstScript)

        // Create and inject noscript fallback into body
        const noscript = document.createElement('noscript')
        noscript.id = 'gtm-noscript'
        const iframe = document.createElement('iframe')
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
        iframe.height = '0'
        iframe.width = '0'
        iframe.style.display = 'none'
        iframe.style.visibility = 'hidden'
        noscript.appendChild(iframe)
        document.body.insertBefore(noscript, document.body.firstChild)
    }, [])
}

export default useGTM
